<template>
  <div
    class="home-parent-card-main-container darker-hover"
    :class="cardStyles.customClass"
    :style="`background-color: ${cardStyles.cardColor};`"
  >
    <div
      class="home-parent-card-container d-flex justify-content-center align-items-center w-100 p-3"
      @click="$router.push(url)"
    >
      <div class="card-image-container w-25 mr-3">
        <img :src="cardImage" alt="" />
      </div>
      <div class="d-flex flex-column justify-content-center w-75">
        <h5 class="home-parent-card-brand font-weight-bold d-sm-flex m-0">
          {{ cardInfo.brand }}
        </h5>
        <span class="">{{ cardInfo.title }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getIcon } from '@/utils/getIcon.js';

export default {
  props: {
    url: {
      type: String,
      default: '',
    },
    cardInfo: {
      type: Object,
      default: () => ({ text: '', brand: '' }),
    },
    cardStyles: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    cardImage() {
      return getIcon(this.cardStyles.icon);
    },
  },
};
</script>
<style scoped lang="scss">
.home-parent-card-main-container {
  max-height: 150px;
  transition: 200ms;
  .home-parent-card-container {
    height: 100%;
    cursor: pointer;
  }
}
.card-image-container {
  height: 100%;
  & > img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
}
span {
  font-size: 16px;
  letter-spacing: 0;
  color: #707070;
}
p {
  font-size: 20px;
  letter-spacing: 0;
  color: #707070;
}
.home-parent-card-main-container:hover {
  transform: scale(1.02) !important;
}
</style>
